/* eslint-env node */

import Routes from './routes';
import { hot } from 'react-hot-loader/root';

export default hot(Routes);
export { Routes };
